import _import from './_import.js';

export default [
    // 手机注册
    {
        path: '/register/mobilephone',
        name: 'mobilephone',
        component: _import('register/mobilephone'),
        meta:{
            title:'mobilephone'
        }
    },
    // 邮箱注册
    {
        path: '/register/email',
        name: 'email',
        component: _import('register/email'),
        meta:{
            title:'email'
        }
    },
    // 用户协议
    {
        path: '/users/agreement',
        name: 'agreement',
        component: _import('register/agreement')
    },
    // 隐私政策
    {
        path: '/users/privacy_policy',
        name: 'privacy_policy',
        component: _import('register/agreement')
    },
    // 注册邮箱激活账户
    {
        path: '/member/activeAccount',
        name: 'active_account',
        component: _import('register/active_account')
    },
    // 注册邮箱激活账户成功
    {
        path: '/member/activeAccountSuc',
        name: 'active_account_suc',
        component: _import('register/active_account_suc')
    }
];


// WEBPACK FOOTER //
// ./src/router/register.js